import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import { Provider } from "./components/ui/provider.tsx";
import { ChooseMaterialPage } from "./pages/choose-codebook.page.tsx";
import { CodebookPage } from "./pages/codebook.page.tsx";
import { CreateCodebookPage } from "./pages/create-codebook.page.tsx";
import { CreateDemandPage } from "./pages/create-demand.page.tsx";
import { CreateEmployeePage } from "./pages/create-employee.page.tsx";
import { CreateCodebookEntryPage } from "./pages/create-entry.page.tsx";
import { CreateCodebookExitPage } from "./pages/create-exit.page.tsx";
import { CreateWarehousePage } from "./pages/create-warehouse.page.tsx";
import { DemandsPage } from "./pages/demands.page.tsx";
import { EmployeesPage } from "./pages/employees.page.tsx";
import { WarehouseEntriesPage } from "./pages/entries.page.tsx";
import { WarehouseExistsPage } from "./pages/exits.page.tsx";
import { LoginPage } from "./pages/login.page.tsx";
import { SingeWarehousePage } from "./pages/single-warehouse.page.tsx";
import { UpdateCodebookWarehousePage } from "./pages/update-codebook-warehouse.page.tsx";
import { WarehousePage } from "./pages/warehouse.page.tsx";
import { ProtectedLayout } from "./utils/layout/protected-layout.tsx";
import { PublicLayout } from "./utils/layout/public-layout.tsx";
import ProtectedRoute from "./utils/protected-route/protected-route.tsx";
import PublicRoute from "./utils/public-route/public-route.tsx";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: Infinity },
  },
});

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path={"/auth"}
          element={
            <PublicRoute>
              <PublicLayout />
            </PublicRoute>
          }
        >
          <Route index element={<LoginPage />} />
        </Route>
        <Route
          path={"/"}
          element={
            <ProtectedRoute>
              <ProtectedLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<></>} />
          <Route path={"/user"} element={<CreateEmployeePage />} />
          <Route path={"/users"} element={<EmployeesPage />} />
          <Route path={"/codebook"} element={<CreateCodebookPage />} />
          <Route path={"/codebooks"} element={<CodebookPage />} />
          <Route
            path={"/codebooks/:id"}
            element={<UpdateCodebookWarehousePage />}
          />
          <Route path={"/warehouse"} element={<ChooseMaterialPage />} />
          <Route path={"/warehouse/:id"} element={<CreateWarehousePage />} />
          <Route path={"/warehouses"} element={<WarehousePage />} />
          <Route path={"/warehouses/:id"} element={<SingeWarehousePage />} />
          <Route
            path={"warehouses/:id/entries/create"}
            element={<CreateCodebookEntryPage />}
          />
          <Route
            path={"warehouses/:id/entries"}
            element={<WarehouseEntriesPage />}
          />
          <Route
            path={"warehouses/:id/demands/create"}
            element={<CreateDemandPage />}
          />
          <Route path={"warehouses/:id/demands"} element={<DemandsPage />} />
          <Route
            path={"warehouses/:id/exits/create"}
            element={<CreateCodebookExitPage />}
          />
          <Route
            path={"warehouses/:id/exits"}
            element={<WarehouseExistsPage />}
          />
        </Route>
      </>,
    ),
  );

  return (
    <Suspense fallback={<></>}>
      <QueryClientProvider client={queryClient}>
        <Provider>
          <RouterProvider router={router} />
        </Provider>
      </QueryClientProvider>
    </Suspense>
  );
}

export default App;
